export default __webpack_public_path__ + "static/img/team.5853bf2.jpg";